<template>
  <div class="flex flex-col gap-3 w-full">
    <!-- Address Display with Copy -->
    <div v-if="showAddress" class="p-4 bg-white rounded-xl border border-vault-border-light">
      <div class="flex items-center justify-between gap-3">
        <div class="flex-1 min-w-0">
          <p class="text-xs text-vault-text-secondary mb-1 font-medium">
            {{ $t('walletSummary.address') }}
          </p>
          <p class="font-mono text-sm text-vault-text-primary truncate">
            {{ address }}
          </p>
        </div>
        <button
          type="button"
          class="p-2.5 rounded-lg hover:bg-vault-bg-secondary transition-colors flex-shrink-0"
          @click="handleCopyAddress"
          :title="addressCopied ? $t('walletSummary.copied') : $t('walletSummary.copyAddress')"
        >
          <svg v-if="!addressCopied" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <rect width="14" height="14" x="8" y="8" rx="2" ry="2"/>
            <path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"/>
          </svg>
          <svg v-else xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="text-vault-success-500">
            <polyline points="20 6 9 17 4 12"/>
          </svg>
        </button>
      </div>
    </div>

    <!-- Action Buttons -->
    <!-- <button
      type="button"
      class="btn-primary w-full flex items-center justify-center gap-2"
      :disabled="loading"
      @click="$emit('deposit')"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <rect width="20" height="14" x="2" y="5" rx="2"/>
        <line x1="2" x2="22" y1="10" y2="10"/>
      </svg>
      {{ $t('walletSummary.deposit') }}
    </button> -->

    <button
      type="button"
      class="btn-primary w-full flex items-center justify-center gap-2"
      :disabled="!canWithdraw || loading"
      @click="$emit('withdraw')"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
        <polyline points="7 10 12 15 17 10"/>
        <line x1="12" x2="12" y1="15" y2="3"/>
      </svg>
      {{ $t('walletSummary.withdraw') }}
    </button>

    <!-- <button
      v-if="claimUrl && emojiPin"
      type="button"
      class="btn-ghost w-full flex items-center justify-center gap-2"
      :disabled="loading"
      @click="$emit('lock')"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <rect width="18" height="11" x="3" y="11" rx="2" ry="2"/>
        <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
      </svg>
      {{ $t('walletSummary.lock') }}
    </button> -->
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

const { t: $t } = useI18n();

const props = withDefaults(defineProps<{
  address: string;
  canWithdraw?: boolean;
  loading?: boolean;
  claimUrl?: string;
  emojiPin?: string;
  showAddress?: boolean;
}>(), {
  canWithdraw: false,
  loading: false,
  claimUrl: '',
  emojiPin: '',
  showAddress: false
});

defineEmits<{
  lock: [];
  deposit: [];
  withdraw: [];
}>();

const addressCopied = ref(false);
let copyTimeout: ReturnType<typeof setTimeout> | null = null;

async function handleCopyAddress() {
  try {
    await navigator.clipboard.writeText(props.address);
    addressCopied.value = true;

    if (copyTimeout) {
      clearTimeout(copyTimeout);
    }

    copyTimeout = setTimeout(() => {
      addressCopied.value = false;
      copyTimeout = null;
    }, 2000);
  } catch (err) {
    console.error('Failed to copy address:', err);
  }
}
</script>

<style scoped>
/* All styles handled by Tailwind */
</style>
